'use client';

import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { TypographyRhythm } from '@jouzen/ecom-components/v3/TypographyRhythm';
import { useTranslations } from 'next-intl';

import TCSection from '../_components/TCSection';
import type { TCData, TCSectionData } from '../_components/types';

const TCContent = (data: TCData) => {
  const t = useTranslations();

  return (
    <section>
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <TypographyRhythm>
            <Typography
              Element="h1"
              variant="h3"
              className="m-0 text-center lg:px-14 lg:pb-9"
            >
              {t(data.title)}
            </Typography>
            {data.sectionData.map((props: TCSectionData) => (
              <TCSection key={props.id} {...props} />
            ))}
          </TypographyRhythm>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default TCContent;
